import { useAppSelector } from '.';

export const useGetMerchantMaxMarketTier = () => {
  return useAppSelector(
    (state) =>
      state.data.merchantLevels.find((ml) => ml.level === state.user.data.level)
        ?.tierUnlock ?? 1
  );
};
